import { Injectable } from "@nestjs/common";
import { AssetStatusEnum } from "libs/shared-models/common-models/src/lib/enum/asset-status.enum";
import { AssetTransfersDto } from "./asset-transfers.dto";
import { AssetTransfer } from "../entity/asset-transfer.entity";

@Injectable()
export class AssetTransfersAdapter{
    public convertDtotoAssetTransferEntity(assetTransfersDto:AssetTransfersDto,isUpdate: boolean = false) : AssetTransfer{
        console.log("assetTransfersDto");
        console.log(assetTransfersDto);
        for(const transferDetails of assetTransfersDto.assetTransfer){
        const assetTransfer = new AssetTransfer();
        assetTransfer.assetLocationId = assetTransfersDto.assetLocationId;
        assetTransfer.assetTransferId = assetTransfersDto.assetTransferId;
        assetTransfer.transferredDate = transferDetails.transferredDate;
        assetTransfer.assetsId = transferDetails.assetsId;
        assetTransfer.indentId = assetTransfersDto.indentId;
        assetTransfer.createdAt = assetTransfersDto.createdAt;
        assetTransfer.createdUser = assetTransfersDto.createdUser;
        assetTransfer.dcNumber = assetTransfersDto.dcNumber;
        assetTransfer.fromPlant = transferDetails.fromPlant;
        assetTransfer.isActive = assetTransfersDto.isActive;
        assetTransfer.mrnNumber = assetTransfersDto.mrnNumber;
        assetTransfer.note = transferDetails.note;
        assetTransfer.receivedDate = assetTransfersDto.receivedDate;
        assetTransfer.receivedQuantity = assetTransfersDto.receivedQuantity;
        assetTransfer.status = assetTransfersDto.status;
        assetTransfer.toPlant = transferDetails.toPlant;
        assetTransfer.transferType = transferDetails.transferType;
        assetTransfer.assetCategoryId = transferDetails.assetCategoryId;
        assetTransfer.transferedQuantity = assetTransfersDto.transferedQuantity;
        assetTransfer.transferredDate = transferDetails.transferredDate;
        assetTransfer.unitId = transferDetails.fromPlant;
        assetTransfer.receivedBy = assetTransfersDto.receivedBy;
        assetTransfer.transferedBy = transferDetails.transferedBy;
        assetTransfer.updatedAt = assetTransfersDto.updatedAt;
        assetTransfer.updatedUser = assetTransfersDto.updatedUser;
        assetTransfer.versionFlag = assetTransfersDto.versionFlag;
        return assetTransfer;
        }

    }

    public convertEntitytoAssetTransferDto(assetTransfer:AssetTransfer) : AssetTransfersDto{
        const assetTransfersDto = new AssetTransfersDto();

        assetTransfersDto.assetLocationId = assetTransfer.assetLocationId;
        assetTransfersDto.assetTransferId = assetTransfer.assetTransferId;
        assetTransfersDto.assetTransfer[0].assetsId = assetTransfer.assetsId;
        assetTransfersDto.indentId = assetTransfer.indentId;
        assetTransfersDto.createdAt = assetTransfer.createdAt;
        assetTransfersDto.createdUser = assetTransfer.createdUser;
        assetTransfersDto.dcNumber = assetTransfer.dcNumber;
        assetTransfersDto.assetTransfer[0].fromPlant = assetTransfer.fromPlant;
        assetTransfersDto.isActive = assetTransfer.isActive;
        assetTransfersDto.mrnNumber = assetTransfer.mrnNumber;
        assetTransfersDto.assetTransfer[0].note = assetTransfer.note;
        assetTransfersDto.receivedDate = assetTransfer.receivedDate;
        assetTransfersDto.receivedQuantity = assetTransfer.receivedQuantity;
        assetTransfersDto.status = assetTransfer.status;
        assetTransfersDto.assetTransfer[0].toPlant = assetTransfer.toPlant;
        assetTransfersDto.assetTransfer[0].transferType = assetTransfer.transferType;
        assetTransfersDto.assetTransfer[0].assetCategoryId = assetTransfer.assetCategoryId;
        assetTransfersDto.transferedQuantity = assetTransfer.transferedQuantity;
        assetTransfersDto.assetTransfer[0].transferredDate = assetTransfer.transferredDate;
        assetTransfersDto.unitId = assetTransfer.unitId;
        assetTransfersDto.receivedBy = assetTransfer.receivedBy;
        assetTransfersDto.assetTransfer[0].transferedBy = assetTransfer.transferedBy;
        assetTransfersDto.updatedAt = assetTransfer.updatedAt;
        assetTransfersDto.updatedUser = assetTransfer.updatedUser;
        assetTransfersDto.versionFlag = assetTransfer.versionFlag;
        return assetTransfersDto;

    }
}